import { useSuspenseQuery } from "@tanstack/react-query";

import { usePostalCodesQuery } from "../../api/get-postal-codes";

const usePostalCodeObject = (code?: string) => {
  const postalCodes = useSuspenseQuery(usePostalCodesQuery());
  const postalCodeObject = postalCodes.data.find(
    (postalCode) => postalCode.code === code,
  );

  return {
    valid: !code || !!postalCodeObject,
    ...postalCodeObject,
  };
};

export { usePostalCodeObject };
